module.exports = __webpack_public_path__ + "static/media/DSC07453.778a3d11.jpg";